<template >
    <div class="form-group table-responsive col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-4">
        <table id="annoucementList" cellspacing="0" width="100%" class="table table-bordered table-striped table-head-fixed" >
            <thead>
                <tr>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Sl.No.</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Title</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Description</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Date of created</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:30%'>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(std, index) in announcementList" :key="index">
                    <td>{{ index + 1 }} </td>
                    <td>{{ std.title }} {{ std.MiddleName }} {{ std.LastName}}</td>
                    <td>{{ std.description}} </td>
                    <td>{{ std.created_at}} </td>
                    <td>
                        <a href="#" class="btn btn-info btn-sm btn-flat text-white" @click="loadeditpage(std)"><span clas="fa fa-eye"></span>Edit</a>
                        <!-- <a href="#" class="btn btn-danger btn-sm btn-flat text-white" @click="Delete(std.id)"><span clas="fa fa-eye"></span>Delete</a> -->
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            announcementList:[],
            dt:'',
            class_form: new form({
                dzongkhag:'',
                org:'',
                class:'',
                stream:'',
                section:'',
            }),
        }
    },
    methods: {
        loadeditpage(data){
            this.$router.push({name:"edit_annocement",params:{data:data}});
        },
        AnnouncementListDetails(){
            this.announcementList =[];
            let uri="";
                uri='announcementList';
                axios.get(uri)
                .then(response => {
                    let data = response.data;
                    this.announcementList = data;
                });
        },
        /**
         * method to remove fields
         */
        Delete(id){
            Swal.fire({
                text: "Are you sure you want to delete from list?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes!',
            }).then((result) => {
                if(result.isConfirmed){
                    axios.get('announcementDelete/'+id)
                    .then(() => {
                        this.announcementList();
                    })
                    .catch((error) => {
                        console.log("Error remove:"+error);
                    })
                }
            });
        },

    },
    
   async mounted(){
        this.AnnouncementListDetails();
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.userId=data.id;;
        })
        // this.dt =  $("#annoucementList").DataTable();
        this.dt = $("#annoucementList").DataTable({
            "order": [[ 0, "asc" ]],
            "lengthChange": false,
            "searching": false,
        }) 
    },

    watch: {
        announcementList() {
            this.dt.destroy();
            this.$nextTick(() => {
                this.dt =  $("#annoucementList").DataTable()
            });
        }
    },
}
</script>
